import { GrowthDataSet } from '../../types/data-set.types';

// WHO Length-for-age BOYS
// Birth to 13 weeks (weekly measurements)
export const whoBoysLengthWeekly: GrowthDataSet = {
  id: 'who-boys-length-weekly',
  source: 'WHO',
  title: 'Length-for-age',
  intervalType: 'week',
  gender: 'male',
  measurementType: 'height',
  ageRange: { min: 0, max: 13 },
  displayUnit: 'cm',
  dataPoints: [
    {
      age: 0,
      m: 49.8842,
      s: 0.03795,
      sd: 1.8931,
      percentiles: {
        p1: 45.5,
        p3: 46.3,
        p5: 46.8,
        p15: 47.9,
        p25: 48.6,
        p50: 49.9,
        p75: 51.2,
        p85: 51.8,
        p95: 53.0,
        p97: 53.4,
        p99: 54.3,
      },
    },
    {
      age: 1, // Week 1
      m: 51.1152,
      s: 0.03723,
      sd: 1.903,
      percentiles: {
        p1: 46.7,
        p3: 47.5,
        p5: 48.0,
        p15: 49.1,
        p25: 49.8,
        p50: 51.1,
        p75: 52.4,
        p85: 53.1,
        p95: 54.2,
        p97: 54.7,
        p99: 55.5,
      },
    },
    {
      age: 2, // Week 2
      m: 52.3461,
      s: 0.03652,
      sd: 1.9117,
      percentiles: {
        p1: 47.9,
        p3: 48.8,
        p5: 49.2,
        p15: 50.4,
        p25: 51.1,
        p50: 52.3,
        p75: 53.6,
        p85: 54.3,
        p95: 55.5,
        p97: 55.9,
        p99: 56.8,
      },
    },
    {
      age: 3, // Week 3
      m: 53.3905,
      s: 0.03609,
      sd: 1.9269,
      percentiles: {
        p1: 48.9,
        p3: 49.8,
        p5: 50.2,
        p15: 51.4,
        p25: 52.1,
        p50: 53.4,
        p75: 54.7,
        p85: 55.4,
        p95: 56.6,
        p97: 57.0,
        p99: 57.9,
      },
    },
    {
      age: 4, // Week 4
      m: 54.3881,
      s: 0.0357,
      sd: 1.9417,
      percentiles: {
        p1: 49.9,
        p3: 50.7,
        p5: 51.2,
        p15: 52.4,
        p25: 53.1,
        p50: 54.4,
        p75: 55.7,
        p85: 56.4,
        p95: 57.6,
        p97: 58.0,
        p99: 58.9,
      },
    },
    {
      age: 5, // Week 5
      m: 55.3374,
      s: 0.03534,
      sd: 1.9556,
      percentiles: {
        p1: 50.8,
        p3: 51.7,
        p5: 52.1,
        p15: 53.3,
        p25: 54.0,
        p50: 55.3,
        p75: 56.7,
        p85: 57.4,
        p95: 58.6,
        p97: 59.0,
        p99: 59.9,
      },
    },
    {
      age: 6, // Week 6
      m: 56.2357,
      s: 0.03501,
      sd: 1.9688,
      percentiles: {
        p1: 51.7,
        p3: 52.5,
        p5: 53.0,
        p15: 54.2,
        p25: 54.9,
        p50: 56.2,
        p75: 57.6,
        p85: 58.3,
        p95: 59.5,
        p97: 59.9,
        p99: 60.8,
      },
    },
    {
      age: 7, // Week 7
      m: 57.0851,
      s: 0.0347,
      sd: 1.9809,
      percentiles: {
        p1: 52.5,
        p3: 53.4,
        p5: 53.8,
        p15: 55.0,
        p25: 55.7,
        p50: 57.1,
        p75: 58.4,
        p85: 59.1,
        p95: 60.3,
        p97: 60.8,
        p99: 61.7,
      },
    },
    {
      age: 8, // Week 8
      m: 57.8889,
      s: 0.03442,
      sd: 1.9925,
      percentiles: {
        p1: 53.3,
        p3: 54.1,
        p5: 54.6,
        p15: 55.8,
        p25: 56.5,
        p50: 57.9,
        p75: 59.2,
        p85: 60.0,
        p95: 61.2,
        p97: 61.6,
        p99: 62.5,
      },
    },
    {
      age: 9, // Week 9
      m: 58.6536,
      s: 0.03416,
      sd: 2.0036,
      percentiles: {
        p1: 54.0,
        p3: 54.9,
        p5: 55.4,
        p15: 56.6,
        p25: 57.3,
        p50: 58.7,
        p75: 60.0,
        p85: 60.7,
        p95: 61.9,
        p97: 62.4,
        p99: 63.3,
      },
    },
    {
      age: 10, // Week 10
      m: 59.3872,
      s: 0.03392,
      sd: 2.0144,
      percentiles: {
        p1: 54.7,
        p3: 55.6,
        p5: 56.1,
        p15: 57.3,
        p25: 58.0,
        p50: 59.4,
        p75: 60.7,
        p85: 61.5,
        p95: 62.7,
        p97: 63.2,
        p99: 64.1,
      },
    },
    {
      age: 11, // Week 11
      m: 60.0894,
      s: 0.03369,
      sd: 2.0244,
      percentiles: {
        p1: 55.4,
        p3: 56.3,
        p5: 56.8,
        p15: 58.0,
        p25: 58.7,
        p50: 60.1,
        p75: 61.5,
        p85: 62.2,
        p95: 63.4,
        p97: 63.9,
        p99: 64.8,
      },
    },
    {
      age: 12, // Week 12
      m: 60.7605,
      s: 0.03348,
      sd: 2.0343,
      percentiles: {
        p1: 56.0,
        p3: 56.9,
        p5: 57.4,
        p15: 58.7,
        p25: 59.4,
        p50: 60.8,
        p75: 62.1,
        p85: 62.9,
        p95: 64.1,
        p97: 64.6,
        p99: 65.5,
      },
    },
    {
      age: 13, // Week 13
      m: 61.4013,
      s: 0.03329,
      sd: 2.044,
      percentiles: {
        p1: 56.6,
        p3: 57.6,
        p5: 58.0,
        p15: 59.3,
        p25: 60.0,
        p50: 61.4,
        p75: 62.8,
        p85: 63.5,
        p95: 64.8,
        p97: 65.2,
        p99: 66.2,
      },
    },
  ],
};
